import { useEffect } from "react";
import Hero from "../components/homepage/Hero";
import ScrollHint from "../components/homepage/dividers/ScrollHint";
import Timeline from "../components/homepage/Timeline";
import Skills from "../components/homepage/Skills";
import Line from "../components/homepage/dividers/Line";
import HomepageContact from "../components/homepage/Contact";
import Projects from "../components/homepage/projects/Projects";

export default function Portfolio() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingCode = urlParams.get("v");

    if (trackingCode) {
      const sourceMap = {
        re: "Resume",
        li: "LinkedIn",
        gh: "GitHub",
        cl: "Cover Letter",
        em: "Email Signature",
        ap: "Application Portal",
        xi: "XING",
      };

      const resolvedSource = sourceMap[trackingCode] || trackingCode;

      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "portfolio_visit", {
          traffic_source: resolvedSource,
        });
      }
    }

    const cleanUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    window.history.replaceState({ path: cleanUrl }, "", cleanUrl);
  }, []);

  return (
    <div className="w-full mx-auto bg-light-bg text-light-text dark:bg-dark-bg dark:text-dark-text font-mono">
      <Hero />
      <ScrollHint />
      <Timeline />
      <Projects />
      <Line />
      <Skills />
      <HomepageContact />
    </div>
  );
}
